<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Нэхэмжлэхийн төлөв
      </p>
    </header>

    <div class="modal-card-body">
      <div class="message is-warning content">
        <div class="message-body">
          <p>
            Гар аргаар төлбөрийг баталгаажуулах гэж байна. Дараах үйлдлүүд
            гүйцэтгэгдэнэ:
          </p>

          <ul>
            <li>Нэхэмжлэхийн төлөв төлөгдсөн болж өөрчлөгдөнө.</li>
            <li>
              Худалдан авагч уруу баримт бүхий и-мэйл илгээнэ.
            </li>
          </ul>
        </div>
      </div>

      <div class="field">
        <b-checkbox v-model="confirmed"
        >Төлбөр гараар баталгаажуулах</b-checkbox
        >
      </div>
    </div>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>

      <button
        class="button is-primary"
        type="button"
        :disabled="!confirmed"
        @click="update"
        :class="{ 'is-loading': form.processing }"
      >
        Төлбөр баталгаажуулах
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["order_id", "updated"],

  data() {
    return {
      confirmed: false,

      form: new window.Form({
        'order_id' : this.order_id
      })
    };
  },

  methods: {
    update() {
      this.form.post("/admin/api/orders/paid-order").then(response => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Төлбөр амжилттай баталгаажлаа."
        });

        this.updated(response.status);

        this.$parent.close();
      });
    }
  }
};
</script>
